import React, { useContext, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { AuthContext } from '../contexts/AuthContext';
import axiosInstance from '../axiosConfig';
import { Link, useNavigate } from 'react-router-dom';
import Notification from '../components/notification/Notification';
import TemplateOne from '../Templates/TemplateOne';
import TemplateTwo from '../Templates/TemplateTwo';
import TemplateThree from '../Templates/TemplateThree';
import TemplateFour from '../Templates/TemplateFour';
import TemplateFive from '../Templates/TemplateFive';
import TemplateSix from '../Templates/TemplateSix';
import TemplateSeven from '../Templates/TemplateSeven';
import TemplateEight from '../Templates/TemplateEight';
import TemplateNine from '../Templates/TemplateNine';
import TemplateTen from '../Templates/TemplateTen';
import TemplateEleven from '../Templates/TemplateEleven';
// import { Circles } from 'react-loader-spinner';
import ResumeSkeleton from './Loading/ResumeSkeleton';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/Homepage.css';

const HomePage = () => {
    const { auth } = useContext(AuthContext);
    const [templates, setTemplates] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [userTemplate, setUserTemplate] = useState(null);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/api/templates/');
            setTemplates(response.data.templates || []);
            setLoading(false);
        } catch (error) {
            //  console.error('Error fetching templates:', error);
            setTemplates([]);
            setLoading(false);
        }
    };

    const fetchUserTemplate = async () => {
        try {
            const response = await axiosInstance.get('/api/userTemplates/current');
            setUserTemplate(response.data);
        } catch (error) {
            //console.error('Error fetching user template:', error);
        }
    };

    useEffect(() => {
        fetchTemplates();
        if (auth) {
            fetchUserTemplate();
        }
    }, [auth]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            window.scrollBy({ top: 800, behavior: 'smooth' });
        }
    };

    const clearSearch = () => {
        setSearchTerm('');
    };

    const handleTemplateClick = async (templateId) => {
        if (auth) {
            try {
                await axiosInstance.post(`/api/userTemplates/copy-template`, { templateId });
                navigate(`/edit-template`);
            } catch (error) {
                setNotification({ message: 'The creation of the user template failed, possibly because the user has been deleted.', isError: true });
            }
        } else {
            navigate('/login');
        }
    };

    const handleGetResumeClick = async () => {
        if (!userTemplate) {
            setNotification({ message: 'No recent template available. Please create a resume first.', isError: true });
            return;
        }

        try {
            setLoading(true);
            const response = await axiosInstance.get(`/api/userTemplates/current`);
            setLoading(false);
            setUserTemplate(response.data);
            navigate(`/user-resume`);
        } catch (error) {
            //console.error('Error fetching favorite template:', error);
            setLoading(false);
            setNotification({ message: 'Error fetching favorite template.', isError: true });
        }
    };

    const scrollMapping = {
        'Professional': 900,
        'Modern': 900,
        'Creative': 900,
        'Simple': 900,
        'Elegant': 900,
        'Classic': 900,
        'Tech-Savvy': 900,
        'Entrepreneur': 900,
        'Analytical': 900,
        'Consultant': 900,
        'Academic': 900,
    };

    const handleTemplateNameClick = (name) => {
        const scrollOffset = scrollMapping[name] || 0;
        window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
        setSearchTerm(name);
    };

    const renderTemplate = (template) => {
        const templateComponents = {
            'Professional': TemplateOne,
            'Modern': TemplateTwo,
            'Creative': TemplateThree,
            'Simple': TemplateFour,
            'Elegant': TemplateFive,
            'Classic': TemplateSix,
            'Tech-Savvy': TemplateSeven,
            'Entrepreneur': TemplateEight,
            'Analytical': TemplateNine,
            'Consultant': TemplateTen,
            'Academic': TemplateEleven,
        };
        const TemplateComponent = templateComponents[template.name] || null;
        return TemplateComponent ? (
            <div className="template-container" key={template.id}>
                <TemplateComponent template={template} onClick={() => handleTemplateClick(template.id)} />
            </div>
        ) : null;
    };

    const filteredTemplates = templates.filter(template =>
        template.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        touchThreshold: 10,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]

    };

    return (
        <div className="homepage-container">
            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}

            {auth ? (
                <div className="dashboard">
                    <h2 className='card'>
                        <strong>Welcome</strong>
                        <strong className='email'>{auth.email}</strong>
                    </h2>

                </div>) :
                (
                    <div className="welcome-message">
                        <h2>Welcome to Resume Builder</h2>
                        <div className="card">
                            Sign up for free to personalize templates to match your unique style and career goals.
                            Upgrade to a premium plan to download and utilize personalized documents for a competitive advantage in your job search.
                        </div>
                    </div>
                )
            }
            {auth ? (
                <div className="dashboard">
                    <div className="dashboard-actions">
                        <Link to="#" onClick={handleGetResumeClick} className="button">
                            Get Your Resume
                        </Link>
                        <Link to="/referral" className="button" >
                            Earn Money
                        </Link>
                        {auth?.isAdmin && <Link to="/admin/totalusers" className="button">Update Commission</Link>}
                        {auth?.isAdmin && <Link to="/admin/tickets" className="button">Manage Ticket</Link>}
                        <Link to="/help-support" className="button">Help & Support</Link>
                        <Link to="/resources" className="button">Tips & Resources</Link>
                    </div>
                </div>
            ) : (
                <div className="dashboard-actions">
                </div>
            )}

            <div className="search-container">
                <input
                    type="text"
                    placeholder="Search templates..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    className="search-input"
                />
                {searchTerm && <button onClick={clearSearch} className="clear-button">X</button>}
            </div>

            <div>
                <Slider {...sliderSettings} className='slider-container'>
                    <div
                        onClick={() => handleTemplateNameClick('Professional')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Professional'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template1.png" alt="Professional Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Modern')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Modern'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template2.png" alt="Modern Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Creative')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Creative'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template3.png" alt="Creative Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Simple')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Simple'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template4.png" alt="Simple Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Elegant')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Elegant'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template5.png" alt="Elegant Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Classic')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Classic'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template6.png" alt="Classic Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Tech-Savvy')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Tech-Savvy'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template7.png" alt="Tech-Savvy Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Entrepreneur')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Entrepreneur'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template8.png" alt="Entrepreneur Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Analytical')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Analytical'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template9.png" alt="Analytical Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Consultant')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Consultant'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template10.png" alt="Consultant Resume" className="slider-image" />
                    </div>
                    <div
                        onClick={() => handleTemplateNameClick('Academic')}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleTemplateNameClick('Academic'); }}
                        tabIndex={0}
                        role="button"
                    >
                        <img src="/images/template11.png" alt="Academic Resume" className="slider-image" />
                    </div>
                </Slider>
            </div>

            <div className="templates-preview">
                <h1>Available Templates</h1>
                <div className="template-list">
                    {loading ? (
                        <div className="loader-container">
                            <ResumeSkeleton />
                        </div>
                    ) : (
                        filteredTemplates.length > 0 ? (
                            filteredTemplates.map((template) => (
                                renderTemplate(template)
                            ))
                        ) : (
                            <div className="card">No templates found.</div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default HomePage;
